import { attendance, examAndGrade, staffAttendance, student } from "../client";

export const getStudentAttendance = (params) => {
  const user = {
    flag: "getStudentAttendance",
    parameters: {
      studentAttendance: params,
    },
  };
  return staffAttendance.post("/search/student/attendance", user);
};

export const updateStudentAttendanceStaff = (params) => {
  const user = {
    flag: "updateStudentAttendance",
    parameters: {
      studentAttendance: params,
    },
  };
  return staffAttendance.post("/update/student/attendance", user);
};

export const uploadStudentAttendance = (params) => {
  console.log(params, "params");
  const user = {
    flag: "biometricAttendance",
    parameters: {
      bioMetricData: {
        base64String: params.base64String,
        institutionId: params.institutionId,
      },
    },
  };
  return examAndGrade.post("/student/biometeric/upload", user);
};

export const downloadTemplate = (params) => {
  const user = {
    flag: "downloadTemplate",
    parameters: {
      attendanceTemplate: params,
    },
  };
  return examAndGrade.post("/student/attendance/template/download", user);
};

export const getStudentAttendanceDetails = (params) => {
  const user = {
    flag: "getStudentAttendanceDetails",
    parameters: {
      admin: params,
    },
  };
  return examAndGrade.post("/admin/get/attendance/student", user);
};

export const getStaffAttendanceDetails = (params) => {
  const user = {
    flag: "getStaffAttendanceDetails",
    parameters: {
      admin: params,
    },
  };
  return staffAttendance.post("/admin/get/attendance/staff", user);
};

export const saveStudentAttendance = (params) => {
  const user = {
    flag: "saveStudentAttendance",
    parameters: {
      studentAttendance: params,
    },
  };
  return staffAttendance.post("/add/student/attendance", user);
};

export const getAttendancePercentage = (params) => {
  // console.log("params",params);
  const user = {
    flag: "getStudentAttendancePercentage",
    parameters: {
      admin: params,
    },
  };
  return student.post("/admin/get/student/attendancePercentage", user);
};

export const getStudentAttendancePercentageDateRangeDepartmentWise = (
  params
) => {
  const data = {
    flag: "getStudentAttendancePercentageDateRangeDepartmentWise",
    parameters: {
      searchStudentAttendanceForAdmin: params,
    },
  };
  return examAndGrade.post(
    `/student/attendance/percentage/departmentwise/date`,
    data
  );
};
export const getStudentAttendancePercentageYearWise = (params) => {
  const data = {
    flag: "getStudentAttendancePercentageYearWise",
    parameters: {
      searchStudentAttendanceForAdmin: params,
    },
  };
  return examAndGrade.post(`/student/attendance/percentage/yearwise`, data);
};
